import Main from "./components/Main.jsx";

function App() {
  return (
    <div className="Main">
      <Main />
    </div>
  );
}

export default App;
